export const EDITOR_ACTIONS = {
  SelectChart: 'SELECT_CHART',
  SelectTable: 'SELECT_TABLE',
  SelectTableColumn: 'SELECT_TABLE_COLUMN',
  SelectQuery: 'SELECT_QUERY',
  RemapSelectedQuery: 'REMAP_SELECTED_QUERY',
  SelectReport: 'SELECT_REPORT',
  ClearSelected: 'CLEAR_SELECTED',

  ShowCart: 'SHOW_CHART',
  ShowTable: 'SHOW_TABLE',
  ShowSQL: 'SHOW_SQL',
  SetView: 'SET_VIEW',

  ToggleSecondarySidebar: 'TOGGLE_SECONDARY_SIDEBAR',
  ToggleVerticalMode: 'TOGGLE_VERTICAL_MODE',
  SetQueryMode: 'SET_QUERY_MODE',
  SetBuilderMode: 'SET_BUILDER_MODE',
  SetNotebookShown: 'SET_NOTEBOOK_SHOWN',
  ToggleMinimize: 'EDITOR_MINIMIZE',
  ToggleMaximize: 'EDITOR_MAXIMIZE',
  QueryRunComplete: 'EDITOR_QUERY_RUN_COMPLETE',
  SelectSchemaTab: 'SELECT_SCHEMA_TAB',

  NotebookRunning: 'NOTEBOOK_RUNNING',
  NotebookWarning: 'NOTEBOOK_WARNING',
  NotebookLoading: 'NOTEBOOK_LOADING',
  NotebookStartSession: 'NOTEBOOK_START_SESSION',
  NotebookSessionLost: 'NOTEBOOK_SESSION_LOST',
  NotebookReady: 'NOTEBOOK_READY',
  NotebookDataOld: 'NOTEBOOK_DATA_OLD',
  NotebookDataLoaded: 'NOTEBOOK_DATA_LOADED',
  NotebookTerminated: 'NOTEBOOK_TERMINATED',

  ReportRunDataLoaded: 'REPORT_RUN_DATA_LOADED',

  OpenFilterPanel: 'OPEN_FILTER_PANEL',
  CloseFilterPanel: 'CLOSE_FILTER_PANEL',
  ToggleFilterPanel: 'TOGGLE_FILTER_PANEL',
};

// RX Actions
export enum EditorActionType {
  ToggleNotebookSidebar = 'ToggleNotebookSidebar',
  ToggleFilterPanel = 'ToggleFilterPanel',
  OverrideFilterPanel = 'OverrideFilterPanel',
  UpdateQueryEditor = 'UpdateQueryEditor',
  InsertQueryText = 'InsertQueryText',
  RunPreviewTableQuery = 'PreviewTable',
  TrackEditSession = 'TrackEditorSession',
}
